// Mock data for Velmora Holidays

export const destinations = [
  {
    id: 'gulmarg',
    name: 'Gulmarg',
    tagline: 'The Meadow of Flowers',
    description: 'Experience the pristine beauty of Gulmarg, famous for its world-class ski resorts and breathtaking gondola rides. As the best travel agency in Kashmir, we offer exclusive Kashmir tour packages to this winter wonderland.',
    highlights: ['Gondola Cable Car', 'Skiing & Snowboarding', 'Alpine Lakes', 'Scenic Meadows'],
    bestTime: 'December to March for snow, May to August for flowers',
    image: '/images/destinations/dest-gulmarg.webp'
  },
  {
    id: 'pahalgam',
    name: 'Pahalgam',
    tagline: 'Valley of Shepherds',
    description: 'Nestled in the Lidder Valley, Pahalgam offers stunning landscapes, rivers, and is the base for the Amarnath Yatra. Our Kashmir tour packages include guided tours by Kashmir tour experts.',
    highlights: ['Betaab Valley', 'Aru Valley', 'Lidder River', 'Trekking Trails'],
    bestTime: 'April to October',
    image: '/images/destinations/dest-pahalgam.webp'
  },
  {
    id: 'sonamarg',
    name: 'Sonamarg',
    tagline: 'Meadow of Gold',
    description: 'Gateway to Ladakh, Sonamarg captivates with golden meadows, glaciers, and pristine mountain streams. Our Kashmir tour expert guides ensure you explore every hidden gem.',
    highlights: ['Thajiwas Glacier', 'Zoji La Pass', 'Trout Fishing', 'Pony Rides'],
    bestTime: 'May to September',
    image: '/images/destinations/dest-sonamarg.webp'
  },
  {
    id: 'dal-lake',
    name: 'Dal Lake',
    tagline: 'Jewel of Srinagar',
    description: 'Stay in traditional houseboats and experience the iconic Shikara rides on the serene Dal Lake. As the best travel agency in Kashmir, we provide authentic houseboat experiences.',
    highlights: ['Houseboat Stay', 'Shikara Rides', 'Floating Gardens', 'Mughal Gardens'],
    bestTime: 'March to November',
    image: '/images/destinations/dest-dal-lake.webp'
  },
  {
    id: 'doodhpathri',
    name: 'Doodhpathri',
    tagline: 'Valley of Milk',
    description: 'Known as the "Valley of Milk" for its pristine white water streams flowing through lush meadows. This untouched paradise is included in our exclusive Kashmir tour packages.',
    highlights: ['Milk-White Streams', 'Green Meadows', 'Horse Riding', 'Photography Heaven'],
    bestTime: 'May to September',
    image: '/images/destinations/dest-doodhpathri.webp'
  },
  {
    id: 'yousmarg',
    name: 'Yousmarg',
    tagline: 'Meadow of Jesus',
    description: 'A hidden gem offering pristine meadows surrounded by dense pine forests and snow-capped peaks. Our Kashmir tour experts reveal this lesser-known paradise to travelers.',
    highlights: ['Dense Pine Forests', 'Doodhganga River', 'Trekking Routes', 'Peaceful Retreat'],
    bestTime: 'April to October',
    image: '/images/destinations/dest-yousmarg.webp'
  },
  {
    id: 'tulip-garden',
    name: 'Tulip Garden',
    tagline: 'Asia\'s Largest Tulip Garden',
    description: 'Witness the spectacular bloom of over 1.5 million tulips at Indira Gandhi Memorial Tulip Garden, the largest in Asia. A must-visit in our Kashmir tour packages during spring.',
    highlights: ['1.5 Million Tulips', '70+ Tulip Varieties', 'Musical Fountain', 'Zabarwan Mountains View'],
    bestTime: 'Late March to Mid-April',
    image: '/images/destinations/dest-tulip-garden.webp'
  },
  {
    id: 'betaab-valley',
    name: 'Betaab Valley',
    tagline: 'Bollywood\'s Paradise',
    description: 'Named after the Bollywood movie "Betaab", this stunning valley offers crystal-clear streams and breathtaking mountain views. Featured in our Kashmir tour packages as a photography hotspot.',
    highlights: ['Crystal Clear Streams', 'Lush Green Meadows', 'Film Shooting Location', 'Adventure Activities'],
    bestTime: 'April to November',
    image: '/images/destinations/dest-betaab-valley.webp'
  }
];

export const packages = [
  {
    id: 1,
    name: 'Kashmir Paradise - 5 Days',
    duration: '5 Days / 4 Nights',
    price: '₹18,999',
    destinations: ['Srinagar', 'Gulmarg', 'Pahalgam'],
    highlights: ['Houseboat Stay', 'Gondola Ride', 'Shikara Ride', 'All Meals'],
    description: 'Experience the best of Kashmir with our curated 5-day package covering iconic destinations.',
    image: '/images/hero-kashmir-600.webp'
  },
  {
    id: 2,
    name: 'Honeymoon Special - 6 Days',
    duration: '6 Days / 5 Nights',
    price: '₹24,999',
    destinations: ['Srinagar', 'Gulmarg', 'Pahalgam', 'Sonamarg'],
    highlights: ['Luxury Houseboat', 'Candlelight Dinner', 'Airport Transfers', 'Flower Decorations'],
    description: 'A romantic getaway designed for couples with special amenities and intimate experiences.',
    image: '/images/hero-kashmir-600.webp'
  },
  {
    id: 3,
    name: 'Adventure Kashmir - 7 Days',
    duration: '7 Days / 6 Nights',
    price: '₹28,999',
    destinations: ['Srinagar', 'Gulmarg', 'Pahalgam', 'Sonamarg'],
    highlights: ['Trekking', 'River Rafting', 'Camping', 'Adventure Sports'],
    description: 'For thrill-seekers! Packed with adventure activities across Kashmir\'s stunning landscapes.',
    image: '/images/hero-kashmir-600.webp'
  },
  {
    id: 4,
    name: 'Family Vacation - 7 Days',
    duration: '7 Days / 6 Nights',
    price: '₹32,999',
    destinations: ['Srinagar', 'Gulmarg', 'Pahalgam', 'Dal Lake'],
    highlights: ['Family-Friendly Activities', 'Spacious Accommodations', 'Local Cuisine', 'Cultural Tours'],
    description: 'Perfect for families with activities suitable for all ages and comfortable stays.',
    image: '/images/hero-kashmir-600.webp'
  },
  {
    id: 5,
    name: 'Winter Wonderland - 4 Days',
    duration: '4 Days / 3 Nights',
    price: '₹16,999',
    destinations: ['Srinagar', 'Gulmarg'],
    highlights: ['Snow Activities', 'Skiing Lessons', 'Warm Accommodations', 'Winter Clothing'],
    description: 'Experience Kashmir in winter with snow activities and cozy mountain retreats.',
    image: '/images/hero-kashmir-600.webp'
  },
  {
    id: 6,
    name: 'Grand Kashmir Tour - 10 Days',
    duration: '10 Days / 9 Nights',
    price: '₹45,999',
    destinations: ['Srinagar', 'Gulmarg', 'Pahalgam', 'Sonamarg', 'Yusmarg'],
    highlights: ['Complete Kashmir Experience', 'Luxury Hotels', 'All Transfers', 'Guided Tours'],
    description: 'The ultimate Kashmir experience covering all major destinations with premium amenities.',
    image: '/images/hero-kashmir-600.webp'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Rajesh & Priya Kumar',
    location: 'Mumbai, Maharashtra',
    rating: 5,
    text: 'Our honeymoon with Velmora Holidays was magical! The houseboat stay and arrangements were perfect. Highly recommend!',
    date: 'January 2025'
  },
  {
    id: 2,
    name: 'Amit Sharma',
    location: 'Delhi',
    rating: 5,
    text: 'Exceptional service from booking to return. The tour guide was knowledgeable and friendly. Kashmir is truly paradise on earth!',
    date: 'December 2024'
  },
  {
    id: 3,
    name: 'Sneha Patel',
    location: 'Ahmedabad, Gujarat',
    rating: 5,
    text: 'Traveled with family and had an amazing time. Velmora Holidays took care of everything. Professional and reliable.',
    date: 'November 2024'
  },
  {
    id: 4,
    name: 'Vikram Singh',
    location: 'Bangalore, Karnataka',
    rating: 5,
    text: 'The adventure package was thrilling! From trekking to river rafting, everything was well-organized. Will definitely book again.',
    date: 'October 2024'
  },
  {
    id: 5,
    name: 'Meera & Arjun',
    location: 'Pune, Maharashtra',
    rating: 5,
    text: 'Best travel agency in Kashmir! Local expertise made all the difference. Beautiful destinations and warm hospitality.',
    date: 'September 2024'
  },
  {
    id: 6,
    name: 'Kavita Reddy',
    location: 'Hyderabad, Telangana',
    rating: 5,
    text: 'Solo traveler here - felt completely safe and welcomed. Velmora team went above and beyond to ensure a memorable trip.',
    date: 'August 2024'
  }
];

export const companyInfo = {
  name: 'Velmora Holidays',
  tagline: 'Your Gateway to Kashmir\'s Wonders',
  location: 'Khayam Chowk, Near Hotel Royal Batoo, Srinagar, Jammu and Kashmir 190001',
  phone: '+91 9419016969',
  email: 'info@velmoraholidays.com',
  whatsapp: '+91 9419016969',
  description: 'Based in the heart of Srinagar at Khayam Chowk, Near Hotel Royal Batoo, Velmora Holidays is recognized as the best travel agency in Kashmir with years of local expertise and a passion for hospitality. Our Kashmir tour expert team crafts unforgettable Kashmir tour packages that showcase the best of our paradise on earth.',
  mission: 'To provide authentic, memorable, and hassle-free Kashmir tour packages that capture the true essence of Kashmir\'s natural beauty and cultural richness. As the best travel agency in Kashmir, we ensure every journey is exceptional.',
  whyChooseUs: [
    'Local Expertise: Kashmir tour experts born and raised in Kashmir, we know every hidden gem',
    'Personalized Service: Customized Kashmir tour packages tailored to your preferences',
    'Reliable Support: 24/7 assistance throughout your journey with the best travel agency in Kashmir',
    'Best Value: Competitive Kashmir tour packages pricing without compromising on quality',
    'Safety First: Your comfort and security are our top priorities',
    'Authentic Experiences: Connect with local culture through our Kashmir tour expert guides'
  ]
};